import { useTranslation } from "react-i18next";

import { getCountryName } from "astrid-helpers/src/countries";

import getCalendarBusinessHours from "../../../utils/getCalendarBusinessHours";

export default function useCalendarEngineerResources({ engineers }) {
	const { t } = useTranslation();

	const resources = engineers.map((engineer) => ({
		id: engineer.id,
		title: engineer.firstName,
		group:
			getCountryName(Object.values(engineer.vendors || {})[0]?.country, false) || t("unassigned", "Unassigned"),
		businessHours: getCalendarBusinessHours({ users: [engineer] }),
		engineer,
	}));

	return { resources, resourceColors: {} };
}
